var englishFormattedEuroCurrency = function (amount, param) {
    if (typeof param === 'number') {
        return new Intl.NumberFormat('en-EN', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: param,
        }).format(amount);
    }
    var formattedCurrencyString = new Intl.NumberFormat('en-EN', {
        style: 'currency',
        currency: 'EUR',
    }).format(amount);
    return param
        ? formattedCurrencyString.replace(/\.00$/, '')
        : formattedCurrencyString;
};
export default englishFormattedEuroCurrency;
